// Die Gestaltungssprache des Werkzeugs.
//
// Herkunft: uebernommen aus dem Netzbetreiber-Navi (Lageplan Tool 2.0), dort
// als CSS-Variablen `--nap-*`. Das war eine ausdrueckliche Ansage vom
// 22.09.2026: Der Verhandlungsbereich soll so aussehen - strenger, mit klaren
// Abschnittsmarken und ruhigen Rahmen statt weicher Kaesten - und der Rest des
// Werkzeugs soll nachziehen.
//
// Warum hier und nicht als CSS-Import aus dem Navi: Das Navi ist ein eigenes
// Projekt mit eigenem Stylesheet, das getrennt ausgeliefert wird. Ein Import
// waere eine Kopplung zwischen zwei Anwendungen. Die Markenfarbe ist in beiden
// dieselbe (#122A5C), der Rest ist bewusst abgeschrieben.
//
// Warum als JS-Objekt und nicht nur als CSS-Variablen: Die Oberflaeche ist
// ueberwiegend mit Inline-Styles gebaut. Die gleichen Werte stehen zusaetzlich
// als CSS-Variablen in App.css (:root), fuer alles, was ueber Klassen laeuft.
// Wer einen Wert aendert, aendert ihn an BEIDEN Stellen.

export const T = {
  navy: '#122A5C',
  ink: '#1C2434',
  body: '#3C4B61',
  muted: '#637083',
  label: '#8A97A8',
  faint: '#B0BAC9',

  hairline: '#EEF2F7',
  randWeich: '#E5E9F0',
  rand: '#D7DEE8',
  randStark: '#B8C3D3',

  flaeche: '#FFFFFF',
  grund: '#F4F7FB',

  orange: '#E07000',
  orangeTinte: '#B35900',

  gut: '#1C8B39',
  gutGrund: '#EAF6EE',
  gutRand: '#CFE9D8',
  warn: '#8A5A00',
  warnGrund: '#FDF8EC',
  warnRand: '#E0C68A',
  gefahr: '#B91C1C',
  gefahrGrund: '#FDF0EF',
  gefahrRand: '#F2C2BD',
  info: '#2B93C4',
  infoGrund: '#EAF3FB',
  infoRand: '#BFDCEC',

  rKarte: 10,
  rChip: 7,
  rFeld: 8,
  rKnopf: 9,

  tLabel: 10,
  tMikro: 10.5,
  tXs: 11,
  tMeta: 11.5,
  tSm: 12,
  tText: 12.5,
  tTitel: 13,
  tPanel: 17,

  spurLabel: '0.18em',
  spurTitel: '-0.025em',
};

// Die Abschnittsmarke des Navi: "1 · DIE FAKTEN". Kleine Versalien, weit
// gesperrt, blass - sie ordnet, ohne sich vorzudraengen. Sie ersetzt die
// frueheren fetten Zwischenueberschriften, die genauso schwer wogen wie der
// Inhalt darunter.
export const ueberzeileStil = {
  fontSize: T.tLabel,
  fontWeight: 700,
  letterSpacing: T.spurLabel,
  textTransform: 'uppercase',
  color: T.label,
};

// Die Karte aus dem Faktenraster: heller Rahmen, kaum Schatten, enger Satz.
export const karteStil = {
  border: `1px solid ${T.randWeich}`,
  borderRadius: T.rKarte,
  background: T.flaeche,
  padding: '12px 12px 10px',
  boxShadow: '0 1px 2px rgba(18, 42, 92, 0.04)',
};

export const knopfStil = (aktiv = false) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 5,
  padding: '6px 10px',
  fontSize: T.tXs,
  fontWeight: 600,
  borderRadius: T.rKnopf,
  border: `1px solid ${aktiv ? T.navy : T.rand}`,
  background: aktiv ? T.navy : T.flaeche,
  color: aktiv ? T.flaeche : T.body,
  cursor: 'pointer',
});

// Der Primaerknopf des Navi ist orange, nicht navy. Es sollte genau einer je
// Leiste sein - waeren es mehrere, zeigte die Farbe nichts mehr an.
export const primaerKnopfStil = {
  ...knopfStil(),
  border: `1px solid ${T.orange}`,
  background: T.orange,
  color: '#FFFFFF',
  fontWeight: 700,
};

export const feldStil = {
  width: '100%',
  padding: '9px 11px',
  fontSize: T.tText,
  border: `1px solid ${T.rand}`,
  borderRadius: T.rFeld,
  fontFamily: 'inherit',
  color: T.ink,
  boxSizing: 'border-box',
};

// Reiter mit orangem Strich unter dem aktiven - im Gespraech, im Abwaegen und
// in der Deals-Liste (stand bis zum 23.09.2026 dreimal gleich im Code).
// nowrap, weil Zaehler in Klammern die Beschriftung wachsen lassen: Mit vier
// Reitern auf 460 px brach "Ergaenzungen (2/3)" sonst zweizeilig um.
export function reiterStil(aktiv) {
  return {
    flex: 1,
    padding: '10px 2px',
    fontSize: T.tMikro,
    fontWeight: 700,
    letterSpacing: '0.02em',
    border: 'none',
    borderBottom: `2px solid ${aktiv ? T.orange : 'transparent'}`,
    background: 'transparent',
    color: aktiv ? T.navy : T.muted,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  };
}

// Die Marke rechts in der Zeile - im Navi "WICHTIG", "PRÜFEN", "NICHT NÖTIG".
export function markeStil(schrift, rand, grund = 'transparent') {
  return {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    flexShrink: 0,
    fontSize: T.tLabel,
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: schrift,
    background: grund,
    border: `1px solid ${rand}`,
    borderRadius: 999,
    padding: '3px 9px',
    whiteSpace: 'nowrap',
  };
}
